module.exports = __webpack_public_path__ + "img/hp_map.png";